module.exports = __webpack_public_path__ + "./images/cd11968bd8ee85d45c799c740cbb15f4.webp";